import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class SplitManagerService {
  dragGutterEmitter = new EventEmitter<any>();
}
